import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { ICard } from "./Props";

interface IClickContainer {
    isClickable?: boolean;
}

const StyledContainer = styled.div<IClickContainer>`
    max-width: 35vw;
    border: ${(props) => `2px solid ${props.theme.border.cool}`};
    padding: 25px 12px 18px;
    background: ${(props) => `linear-gradient(
        45deg, ${props.theme.primary.main}, ${props.theme.secondary.main}
    )`};
    margin: 1vmin;
    height: max-content;
    @media (max-width: 500px) {
        padding-top: 20px;
    }
`;

const Title = styled.h2`
    color: #fff;
    font-weight: 300;
    @media (max-width: 500px) {
        font-size: 1rem;
    }
`;

const Date = styled.div`
    color: #ccc;
    font-weight: 300;
    margin: 6px 0;
    @media (max-width: 500px) {
        font-size: 0.8rem;
    }
`;

const Description = styled.p`
    color: #fff;
    font-weight: 300;
    @media (max-width: 500px) {
        font-size: 0.75rem;
    }
`;

const Actions = styled.div`
    color: #333;
    display: flex;
    align-items: center;
    svg {
        transform: translateY(2px);
        margin-right: 5px;
    }
    @media (max-width: 500px) {
        flex-direction: column;
        & button {
            width: 100%;
            margin-bottom: 4px;
            font-size: 0.65rem;
        }
    }
`;

const ActionButton = styled.button`
    margin: 0 5px;
    padding: 8px 14px;
    background: rgba(155, 155, 155, 0.2);
    color: #fff;
    cursor: pointer;
    border: 1px solid #fff;
    outline: 0;
    font-weight: 300;
    :hover {
        opacity: 0.8;
    }
    :active {
        background: ${(props) => props.theme.primary.main};
    }
`;

const StyledPhoto = styled.img`
    // width: 100%;
    // height: 100%;
    object-fit: cover;
    border: ${(props) => `1px solid ${props.theme.border.cool}`};
`;

const theme = {
    main: "royalblue",
    border: {
        cool: "black",
    },
    primary: {
        main: "#553C8B",
    },
    secondary: {
        main: "#F2F4D1",
    },
};

const Card: React.FC<ICard> = ({
    title,
    date,
    description,
    buttons,
    srcImg,
    onClick,
}) => (
    <ThemeProvider theme={theme}>
        <StyledContainer
            isClickable
            onClick={() => onClick && onClick()}
        >
            <StyledPhoto src={srcImg} />
            <Title>{title}</Title>
            <Date>{date}</Date>
            <Description>{description}</Description>
            {buttons && (
                <Actions>
                    {buttons.map(({ label, onClick }: any, index: number) => (
                        <ActionButton onClick={onClick} key={index}>
                            {label}
                        </ActionButton>
                    ))}
                </Actions>
            )}
        </StyledContainer>
    </ThemeProvider>
);

export default Card;
